import type { EfficiencyInput } from '@brt/shared-types'
import type { AppStore } from '../useAppStore.ts'

export interface EfficiencySlice {
  efficiency: EfficiencyInput
  setEfficiency: (updates: Partial<EfficiencyInput>) => void
  toggleEfficiency: () => void
}

const DEFAULT_EFFICIENCY: EfficiencyInput = {
  efficiencyPercent: 0.93,
  includeEfficiency: false,
  description: 'DC-DC converter',
}

type Set = (fn: (state: AppStore) => Partial<AppStore>) => void

export function createEfficiencySlice(set: Set): EfficiencySlice {
  return {
    efficiency: { ...DEFAULT_EFFICIENCY },

    setEfficiency: (updates) =>
      set((state) => ({
        efficiency: { ...state.efficiency, ...updates },
      })),

    toggleEfficiency: () =>
      set((state) => ({
        efficiency: { ...state.efficiency, includeEfficiency: !state.efficiency.includeEfficiency },
      })),
  }
}

export { DEFAULT_EFFICIENCY }
